import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Button, Table, Container, Spinner, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import ListPagination from '../../../common/ListPagination';

import { fetchMobileAppBanners, SET_MOBILE_APP_BANNERS_PAGINATION } from '../../../store/actions/mobileappbanner/mobileAppBannerActions';
import PageTitle from '../../../common/PageTitle';

class MobileAppBanners extends Component {
  componentDidMount() {
    this.props.fetchMobileAppBanners();
  }

  renderMobileAppBanners = () => {
    const mobileappbanners = this.props.mobileappbanners.mobileappbanners;
    let mobileappbannerList = [];

    if (mobileappbanners) {
      mobileappbannerList = mobileappbanners.length ? (
        mobileappbanners.map((mobileappbanner, key) => {
          const status = mobileappbanner.status === 1 ? 'Draft' : 'Published';

          return (
            <tr key={key}>
              <td><img alt={mobileappbanner.image_url} src={mobileappbanner.image_url} /></td>
              <td className="align-center"><a href={mobileappbanner.external_url}>{mobileappbanner.external_url}</a></td>
              <td className="align-center">{status}</td>
              <td className="align-center">{mobileappbanner.updated_at}</td>
              <td className="align-center">
                <div className="align-center action-btns">
                  <Button
                    size="sm"
                    className="btn-icon ml-3"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.history.push('/mobile-app-banner/edit?id=' + mobileappbanner.id);
                    }}
                  >
                    <FontAwesomeIcon icon={faPen} /> Edit
                  </Button>
                </div>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={7}><Spinner animation="border" size="sm" /></td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td colSpan={7}><p className="text-danger">No Results found.</p></td>
        </tr>
      );
    }

    return mobileappbannerList;
  };

  render() {
    const {
      currentPage,
      totalPages,
      numItems,
      min,
      max,
    } = this.props.mobileappbanners;


    const upsertMobileAppBanner = (
      <Button
        id="add-client"
        size="md"
        onClick={() => {
          this.props.history.push('/mobile-app-banner/new');
        }}
      >
        Add App Banner
      </Button>
    );

    return (
      <div>
        <Container className="waa-container">
          <PageTitle pageName="MOBILE APP BANNER" actionButton={upsertMobileAppBanner} />

          <Row>
            <Col>
              <div className="float-right">
                <ListPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  numItems={numItems}
                  min={min}
                  max={max}
                  dispatchType={SET_MOBILE_APP_BANNERS_PAGINATION}
                  fetchCallback={() => {
                    this.props.fetchMobileAppBanners();

                    // this.renderMobileAppBanners();
                  }} />
              </div>
            </Col>
            <Table className="waa-table mobileappbanners">
              <thead>
                <tr>
                  <th>IMAGE</th>
                  <th>EXTERNAL URL</th>
                  <th>STATUS</th>
                  <th>LAST UPDATED</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {this.renderMobileAppBanners()}
              </tbody>
            </Table>
            <Col>
              <div className="float-right">
                <ListPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  numItems={numItems}
                  min={min}
                  max={max}
                  dispatchType={SET_MOBILE_APP_BANNERS_PAGINATION}
                  fetchCallback={() => {
                    this.props.fetchMobileAppBanners();

                    // this.renderMobileAppBanners();
                  }} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mobileappbanners: state.mobileappbanners,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMobileAppBanners: (...args) => dispatch(fetchMobileAppBanners(...args)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileAppBanners));
